import { InjectionToken } from "@angular/core";
import { AutoBonusPaymentsPort } from "./auto-bonus-payments.port";

export const AUTO_BONUS_PAYMENTS_PORT =
  new InjectionToken<AutoBonusPaymentsPort>("AUTO_BONUS_PAYMENTS_PORT");
